export default __webpack_public_path__ + "static/media/Potion of Intellect (4h).e0d2a413.jpg";